module.exports = "<a :href=\"link\" v-link=\"routerLink\" class=\"weui_grid\">\n  <div class=\"weui_grid_icon\" v-if=\"imageUrl\">\n    <img :src=\"imageUrl\" alt=\"\">\n  </div>\n  <p class=\"weui_grid_label\" v-if=\"label\">{{label}}</p>\n</a>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/grids/grid.vue
 ** module id = 124
 ** module chunks = 0
 **/